import { useState } from "react";
import { useTheme } from "@/context/ThemeContext";


export const GenisLogo = ({ height = 36, forceDark = false }) => {
  const [failed, setFailed] = useState(false);
  const { isLight } = useTheme();
  const light = isLight && !forceDark;
  return (
    <span data-testid="genis-logo" className="inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-[var(--mute)]">
      Propulsé par
      {failed ? (
        <b className="font-display text-sm normal-case tracking-normal text-[#3FB3E0]">Genis</b>
      ) : (
        <img src={light ? "/img/genis-logo-light.png" : "/img/genis-logo.jpg"} alt="Genis Energie" style={{ height }} className="w-auto rounded" onError={() => setFailed(true)} />
      )}
    </span>
  );
};

export const LogoMark = ({ size = 34 }) => (
  <span
    className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white"
    style={{ width: size, height: size }}
  >
    <img src="/img/logo-mark.png" alt="" aria-hidden="true" style={{ width: size * 0.86, height: size * 0.86 }} className="object-contain" />
  </span>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2 sm:gap-3">
    <LogoMark size={38} />
    {!compact && (
      <span className="leading-none">
        <span className="font-display block text-[14px] font-extrabold tracking-wide text-[#3FB3E0] sm:text-[17px]">GROUPE CONNECT</span>
        <span className="mt-1 block text-[9px] font-mono uppercase tracking-[0.22em] text-[var(--accent-text)] sm:text-[10px] sm:tracking-[0.28em]">
          Portail Client CEE
        </span>
        <span className="mt-1 block text-[9px] text-[var(--mute)]">by Genis</span>
      </span>
    )}
  </span>
);
